
import { CostCentreMetadataBase } from './cost-centre.metadata.base';


export class CostCentreMetadata extends CostCentreMetadataBase {
  constructor() {
    super();
  }
}

export const COST_CENTRE_METADATA: CostCentreMetadata = new CostCentreMetadata();


